export default __webpack_public_path__ + "static/media/no-cover.cbd9003e.png";